"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OuterFilterSchema = exports.FilterColumnSchema = exports.ReportTypeSchema = void 0;
const zod_1 = require("zod");
exports.ReportTypeSchema = zod_1.z.enum(["DigiRodeo"]);
exports.FilterColumnSchema = zod_1.z.object({
    name: zod_1.z.string(),
    field: zod_1.z.string().optional(),
    column: zod_1.z.string().optional(),
    display: zod_1.z.boolean(),
    getList: zod_1.z.boolean().optional(),
    source: zod_1.z.string().optional(),
    dateField: zod_1.z.boolean().optional(),
    type: zod_1.z.enum(["text", "number", "multiSelect", "dateRange"]).optional(),
    disableInnerFilter: zod_1.z.boolean().optional(),
    disableSorting: zod_1.z.boolean().optional(),
    columnWidth: zod_1.z.string().optional(),
    outerFilter: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional()
});
exports.OuterFilterSchema = zod_1.z.object({
    label: zod_1.z.string().optional(),
    key: zod_1.z.string(),
    key2: zod_1.z.string().optional(),
    type: zod_1.z.enum(['number', 'text', 'dateRange', 'multiselect', 'date']),
    variant: zod_1.z.enum(['standard', 'outlined']).optional(),
    required: zod_1.z.boolean(),
    inputProps: zod_1.z.object({
        min: zod_1.z.number(),
        step: zod_1.z.number()
    }).optional(),
    diablePast: zod_1.z.boolean().optional(),
    options: zod_1.z.array(zod_1.z.object({
        label: zod_1.z.string(),
        value: zod_1.z.string()
    })).optional(),
    customUpdate: zod_1.z.boolean().optional(),
    customOther: zod_1.z.boolean().optional()
});
